/**
 * MoveAudio/index.js
 * Handles the move audio playing when a piece is moved.
 * The move audio is within public/audio/piece-move.mp3.
 *
 * @author Braden Zingler
 * Last modified 09/17/24
 */
import { useCallback } from "react";
import { soundManager } from "./audioManager";

const usePlayAudio = () => {
    return useCallback(() => {
        try {
            soundManager.play("move", { volume: 0.3 + Math.random() * 0.2 });
        } catch (error) {
            console.error("Error playing move sound:", error);
        }
    }, []);
};

export default usePlayAudio;
